import { showErrorBar } from 'actions/errorBar';
import { ERROR } from 'constants/error-severities';
import { getGraphQLClient } from 'utilities/graphql';
import { MEMBER_TYPE_INVITED } from 'utilities/organization-members';
import * as sentry from 'utilities/sentry';

import GetWorkspaceMembers from './GetWorkspaceMembers.graphql';
import {
  setFetchingTeamMembers,
  setTeamMembers,
} from '../actions/team-members.js';

const combineAcceptedAndInvitedUsers = (accepted, invited) => {
  const acceptedMembers = accepted.map(acc => {
    return {
      memberRole: acc.member_role,
      memberStatus: acc.member_status,
      ...acc.user,
    };
  });

  const invitedMembers = invited.map(invite => {
    return {
      memberRole: invite.org_role,
      memberStatus: MEMBER_TYPE_INVITED,
      ...invite,
    };
  });

  return [...acceptedMembers, ...invitedMembers];
};

export const fetchTeamMembers = workspaceId => {
  return async dispatch => {
    const gqlClient = getGraphQLClient();

    dispatch(setFetchingTeamMembers(true));

    try {
      const { data } = await gqlClient.query({
        query: GetWorkspaceMembers,
        variables: {
          workspaceId,
        },
        fetchPolicy: 'no-cache',
      });

      const { users } = data;
      const { accepted, invited } = users;

      const combined = combineAcceptedAndInvitedUsers(accepted, invited);

      dispatch(setTeamMembers(combined));
    } catch (err) {
      dispatch(showErrorBar(ERROR, 'Unable to fetch team members'));
      sentry.logException(
        err,
        'fetchTeamMembers: Unable to fetch team members'
      );
    }

    dispatch(setFetchingTeamMembers(false));
  };
};
